var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 55C43.807 55 55 43.807 55 30C55 16.1929 43.807 5 30 5C16.1929 5 5 16.1929 5 30C5 43.807 16.1929 55 30 55ZM26.7337 39.6145L38.5343 32.6475C40.4885 31.4935 40.4885 28.5065 38.5343 27.3525L26.7337 20.3855C24.8343 19.264 22.5 20.7237 22.5 23.0329V36.967C22.5 39.2763 24.8343 40.736 26.7337 39.6145Z",
    fill: "#4ECB71"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.d2a649cc97c8a204be49a7b7f708f353.svg";
export { ForwardRef as ReactComponent };